import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { selectBrand, selectContent, useAppSelector } from '@open-tender/cloud'
import {
  Content,
  GiftCardsForm,
  FormWrapper,
  Main,
  PageTitle,
  HeaderDefault,
  PageContainer,
} from 'components'

const GiftCards = () => {
  const navigate = useNavigate()
  const { giftCards: config } = useAppSelector(selectContent) || {}
  const brand = useAppSelector(selectBrand)
  const { title, has_gift_cards } = brand || {}
  // Not yet in the published @open-tender/types Brand shape; ext_gift_card_url
  // is a newer order-api config field. Remove this cast once that catches up.
  const { ext_gift_card_url } =
    (brand as { ext_gift_card_url?: string | null } | null) || {}

  useEffect(() => {
    if (ext_gift_card_url) {
      window.location.href = ext_gift_card_url
    } else if (!has_gift_cards) {
      navigate('/account')
    }
  }, [ext_gift_card_url, has_gift_cards, navigate])

  return (
    <>
      <Helmet>
        <title>
          {config?.title} | {title}
        </title>
      </Helmet>
      <Content>
        <HeaderDefault />
        <Main>
          <PageContainer style={{ maxWidth: '76.8rem' }}>
            <PageTitle {...config} />
            <FormWrapper>
              <GiftCardsForm />
            </FormWrapper>
          </PageContainer>
        </Main>
      </Content>
    </>
  )
}

export default GiftCards
